module.exports = __webpack_public_path__ + "media/newstyle/images/icon-americanas-fabc024964ce7cfa841c1d005b3638f2.svg";